import React from 'react'
import AutorenewRoundedIcon from '@mui/icons-material/AutorenewRounded'
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined'
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded'
import CloudOutlinedIcon from '@mui/icons-material/CloudOutlined'
import CropFreeRoundedIcon from '@mui/icons-material/CropFreeRounded'
import CropLandscapeOutlinedIcon from '@mui/icons-material/CropLandscapeOutlined'
import CropPortraitOutlinedIcon from '@mui/icons-material/CropPortraitOutlined'
import ExploreOutlinedIcon from '@mui/icons-material/ExploreOutlined'
import FlightOutlinedIcon from '@mui/icons-material/FlightOutlined'
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined'
import GridOnOutlinedIcon from '@mui/icons-material/GridOnOutlined'
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined'
import MeetingRoomOutlinedIcon from '@mui/icons-material/MeetingRoomOutlined'
import PhoneIphoneOutlinedIcon from '@mui/icons-material/PhoneIphoneOutlined'
import RateReviewOutlinedIcon from '@mui/icons-material/RateReviewOutlined'
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded'
import StraightenOutlinedIcon from '@mui/icons-material/StraightenOutlined'
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined'
import TuneRoundedIcon from '@mui/icons-material/TuneRounded'
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined'
import ViewInArOutlinedIcon from '@mui/icons-material/ViewInArOutlined'
import WifiOutlinedIcon from '@mui/icons-material/WifiOutlined'

import { GRAY_700 } from 'constants/styling/theme'

/**
 * Glyph per service-term name. The names are the designer's vocabulary, carried
 * through the scrape; an unknown one falls back rather than rendering nothing,
 * because marketing can add a term to a portfolio page at any time.
 */
const ICONS: Readonly<Record<string, React.ElementType>> = {
  amends: AutorenewRoundedIcon,
  camera: CameraAltOutlinedIcon,
  certified: VerifiedOutlinedIcon,
  compass: ExploreOutlinedIcon,
  delivery: LocalShippingOutlinedIcon,
  drone: FlightOutlinedIcon,
  edit: TuneRoundedIcon,
  features: TuneRoundedIcon,
  feedback: RateReviewOutlinedIcon,
  floorplan: GridOnOutlinedIcon,
  folder: FolderOutlinedIcon,
  horizontal: CropLandscapeOutlinedIcon,
  hosting: CloudOutlinedIcon,
  image: ImageOutlinedIcon,
  load: TimerOutlinedIcon,
  matterport: ViewInArOutlinedIcon,
  onoff: WifiOutlinedIcon,
  roomfunction: MeetingRoomOutlinedIcon,
  scale: StraightenOutlinedIcon,
  smartphone: PhoneIphoneOutlinedIcon,
  stamp: CheckCircleOutlineRoundedIcon,
  time: ScheduleRoundedIcon,
  valid: CropFreeRoundedIcon,
  vertical: CropPortraitOutlinedIcon,
  videocamera: CameraAltOutlinedIcon,
}

export const ProductTermIcon: React.FC<{ icon: string }> = ({ icon }) => {
  const Glyph = ICONS[icon] ?? InfoOutlinedIcon
  return <Glyph sx={{ fontSize: '2rem', color: GRAY_700, flexShrink: 0 }} />
}
